const e = "Clear search field", a = "Select option", c = {
  clearSearch: e,
  selectPlaceholder: a,
  "Select.InputSearch.Value:placeholder": "Search",
  "Select.InputSearch.Value:aria-label": "Search"
};
export {
  e as clearSearch,
  c as default,
  a as selectPlaceholder
};
